import { Attrs, EventListeners, MinzeElement, Reactive } from 'minze'
import { BlogCardData } from './lvc-blog-slider'
import { Locale } from '../../modules/locale'
const lang = Locale.language as 'fr' | 'en'
export interface LvcBlogCard {
  parsedData: BlogCardData | null
}
export class LvcBlogCard extends MinzeElement {
  attrs: Attrs = ['data']
  reactive: Reactive = [
    ['parsedData', null],
    ['isHovered', false],
  ]
  onRender = () => {
    this.parsedData = JSON.parse(decodeURIComponent(this.data as string)) as BlogCardData
  }
  handleMouseOver = () => {
    this.isHovered = true
  }
  handleMouseLeave = () => {
    this.isHovered = false
  }
  html = () => {
    if (this.loading) {
      return `
        <div class="blog-card is-loading">
          
        </div>
      `
    }
    if (!this.parsedData) return ''
    return /*html*/ `
      <a class="blog-card" key="${this.parsedData.id}" href="${this.parsedData.data.urlConstruct?.[lang]}">
        <div class="blog-card-image-wrapper">
          <div class="image-overlay"></div>
          ${
            this.parsedData.data.image
              ? /*html*/ `
            <lvc-image data-image-remove-mask="true" src="${this.parsedData.data.image}" alt="${this.parsedData.data?.imageAltText || ''}"></lvc-image>`
              : /*html*/ `
            <lvc-blog-hand-icon></lvc-blog-hand-icon>
            `
          }
        </div>
        <div class="blog-card-content-wrapper">
          <div class="blog-card-tag-wrapper">
            ${
              this.parsedData?.data?.categoryLabel
                ? /*html*/ `
              <div class="blog-card-category">
                  <lvc-tag-icon></lvc-tag-icon>
                  ${this.parsedData.data.categoryLabel?.[lang]}
              </div>
            `
                : ''
            }
            <div class="blog-card-reading-time">
              <lvc-clock-icon width="10px" height="10px"></lvc-clock-icon>
              ${this.parsedData.data.readingTimeLabel?.[lang]}
            </div>
          </div>
          
          <div class="blog-card-title">${this.parsedData.data.title?.[lang]}</div>
          <div class="blog-card-author-layout">
            <div class="blog-card-author-image-wrapper">
              ${
                this.parsedData?.data?.authorImage
                  ? /*html*/ `
                <img src="${this.parsedData.data.authorImage}" class="blog-card-author-image" alt="${this.parsedData.data.authorName}">
              `
                  : `${lvcBlogCardAuthorPlaceholder}`
              }
            </div>
            <div class="blog-card-author-text-wrapper">
              <div class="blog-card-author">${this.parsedData.data.authorName?.[lang]}</div>
              <div class="blog-card-publish-at">${this.parsedData.data.publishAtLabel?.[lang]}</div>
            </div>
          </div>
        </div> 
        
  </a>
    `
  }
  css = () => `
    lvc-image, lvc-image::part(image) {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    lvc-clock-icon, lvc-clock-icon::part(icon) {
      width: 20px;
      height: 20px;
    }
    lvc-image::part(image) {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .blog-card-category{
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 0.75rem;
    }
    .blog-card-author{
      font-weight: 800;
    }
    .blog-card-publish-at{
      font-size: 0.75rem;
    }
    .blog-card-title {
      color: ${this.parsedData?.data?.image ? '#1E007D' : '#FF4600'};
      font-size: 1.25rem;
      line-height: 1.3;
      font-weight: 800;
      margin: 10px 0;
      line-clamp: 3;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;

    }
    a {
      height: 100%;
      color: #1E007D;
      text-decoration: none;
      display: flex;
      flex-direction: column;
    }
    .blog-card-content-wrapper {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      padding: 20px;
    }
    .blog-card-author-layout {
      margin-top: auto;
      display: flex;
      align-items: center;
      gap: 8px;
      
    }
    .blog-card-author-image-wrapper {
      height: 30px;
      width: 30px;
      background: #BFF0FF;
      border-radius: 100%;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .blog-card-author-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .blog-card-tag-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      column-gap: 8px;
    }
    .blog-card-image-wrapper {
      position: relative;
      height: 180px;
      width: 100%;
    }
    lvc-blog-hand-icon {
      position: absolute;
      margin: auto;
      inset: -58px 0 0 50px;
      width: 92px;
      height: 132px;
      transform: rotate(3deg);
    }

    .blog-card-reading-time {
      
      display: flex;
      align-items: center;

      gap: 4px;
      font-size: 0.75rem;
    }
    :host {
      overflow: hidden;
      border-radius: 10px;
      background: ${this.parsedData?.data?.image ? '#ffffff' : '#DCFFD7'};
      height: 410px;
      font-size: 0.875rem;
      width: 100%;
    }
    .image-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #1E007D;
      transition: opacity 0.2s;
      opacity: ${this.isHovered ? '0.6' : '0'};
    }
    .blog-card.is-loading {
      min-height: 300px;
    }
    @media screen and (max-width: 768px) {

    }
    @media screen and (max-width: 480px) {
      .blog-card-tag-wrapper {
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
      }
    }
  `
  eventListeners?: EventListeners | undefined = [
    [this, 'mouseover', this.handleMouseOver],
    [this, 'mouseleave', this.handleMouseLeave],
  ]
}

const lvcBlogCardAuthorPlaceholder = /*html*/ `
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.73685 15.4872C3.05338 15.4526 4.52509 15.3243 6.43155 15.3243C7.35558 15.3243 10.0609 15.3796 11.4933 15.3791C12.4602 15.3787 13.3285 15.3531 14.0706 15.3403C14.6108 15.331 15.0543 14.8933 14.9943 14.3564C14.7881 12.512 13.9785 9.82624 11.8002 8.92344C8.53676 7.57091 5.1288 8.3868 3.45825 10.4459C2.12181 12.0931 1.16414 14.4221 1.01318 15.3243M8.15545 1.01653C9.87081 0.910227 11.2085 2.33119 11.2085 3.95218C11.2085 5.57318 9.96649 6.56114 8.40668 6.56114C6.84688 6.56114 5.50371 5.4587 5.50371 3.8377C5.50371 2.3856 6.54326 1.16421 7.876 0.928711" stroke="#1E007D" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
`
